module.exports = __webpack_public_path__ + "static/media/sharepoint.08aaf073.svg";